import type React from "react";
import type {DashboardItem} from "./services/dashboardsApi";
import {GENERIC_THUMB, layoutToThumbCells} from "./dashboards.utils";

/** 104px CSS miniature of the dashboard's layout (design: DshThumb). */
export const DashboardThumb: React.FC<{dashboard: DashboardItem}> = ({dashboard}) => {
    const cells = dashboard.layoutHint.length ? layoutToThumbCells(dashboard.layoutHint) : GENERIC_THUMB;
    const generic = !dashboard.layoutHint.length;
    return (
        <span className={`dsh-thumb${generic ? " dsh-thumb--generic" : ""}`} aria-hidden="true" data-testid="dsh-thumb">
            {cells.map((c, i) => (
                <span key={i} className={`b b--${c.kind}`}
                      style={{gridColumn: c.newRow ? `1 / span ${c.span}` : `span ${c.span}`}}/>
            ))}
        </span>
    );
};
